import React from "react";
import "./InsuranceCard.scss";
import { ImageInsurance } from "./ImageInsurance";
import { images } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  removeInsuranceFromProposal,
  removeUpdatingInsuranceAdded,
  setInsuranceUpdatingInProposal,
  updatingInsuranceAdded,
} from "../../actions/proposal";
import { openModal } from "../../actions/ui";
import ModalProposal from "../Modals/ModalProposal";
import InsuranceCardForEditing from "./InsuranceCardForEditing";
import { numberNotation } from "../../helper/numberStructure";
const InsuranceCard = ({ insurance }) => {
  const { provider, type, startDate, endDate, total, _id } = insurance;
  const dispatch = useDispatch();
  const { modalOpen } = useSelector((state) => state.ui);
  const { updatingInsurance } = useSelector((state) => state.proposals);

  const handleEditInsurance = (insurance) => {
    dispatch(openModal());
    dispatch(updatingInsuranceAdded());
    dispatch(setInsuranceUpdatingInProposal(insurance));
  };

  const handleDeleteInsurance = (insuranceId) => {
    dispatch(removeInsuranceFromProposal(insuranceId));
  };

  return (
    <div className="insurance-card">
      <div className="insurance-card__wrap">
        <div className="insurance-card__heading">
          <div className="insurance-card__heading--image">
            <ImageInsurance provider={provider} />
          </div>
          <div className="insurance-card__heading--title">
            <div>
              <p className="title-gray-black-18">{provider}</p>
              <p className="paragraph-gray-reg-16">{type}</p>
            </div>
          </div>
          <div className="insurance-card__heading--button">
            <button onClick={() => handleEditInsurance(insurance)}>
              <img src={images.IconEdit} alt="" />
            </button>
            <button onClick={() => handleDeleteInsurance(_id)}>
              <img src={images.IconDelete} alt="" />
            </button>
          </div>
        </div>

        <div className="card-insurance__prices">
          <div className="card-insurance__prices--item">
            <p className="paragraph-gray-reg-14">Start</p>
            <p className="title-gray-bold-14">{startDate}</p>
          </div>
          <div className="card-insurance__prices--item">
            <p className="paragraph-gray-reg-14">End</p>
            <p className="title-gray-bold-14">{endDate}</p>
          </div>
          <div className="card-insurance__prices--item">
            <p className="paragraph-gray-reg-14">Total</p>
            <p className="title-gray-black-18">A$ {numberNotation(total)}</p>
          </div>
        </div>
      </div>
      {modalOpen && updatingInsurance && (
        <ModalProposal clean={removeUpdatingInsuranceAdded}>
          <InsuranceCardForEditing />
        </ModalProposal>
      )}
    </div>
  );
};

export default InsuranceCard;
